// Icônes des objets-runes (majeures + mineures) + croquis (sketches). Atlas
// 2560×2560, cases 64×64, rangée 0 dans l'ordre : majeure puis ses mineures
// (0-10), puis les 6 croquis (11-16), puis les 11 mineures standalone (17-27).

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

const CELL = 64;

const cell = (index: number) => ({
  frame: { x: index * CELL, y: 0, w: CELL, h: CELL },
  sourceSize: { w: CELL, h: CELL },
  spriteSourceSize: { x: 0, y: 0, w: CELL, h: CELL },
});

export const RuneIconsSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'rune-icons',
    metadata: {
      frames: {
        walkman: cell(0),
        earphones: cell(1),
        mixtape: cell(2),
        camera: cell(3),
        flashbulb: cell(4),
        'film-roll': cell(5),
        pocketknife: cell(6),
        sheath: cell(7),
        'baseball-glove': cell(8),
        'baseball-bat': cell(9),
        'baseball-mask': cell(10),
        'sketch-joy': cell(11),
        'sketch-sadness': cell(12),
        'sketch-anger': cell(13),
        'sketch-fear': cell(14),
        'sketch-surprise': cell(15),
        'sketch-disgust': cell(16),
        'bright-charm': cell(17),
        'gloom-charm': cell(18),
        'fury-charm': cell(19),
        'dread-charm': cell(20),
        'flash-charm': cell(21),
        'rot-charm': cell(22),
        'vigor-band': cell(23),
        'keen-edge': cell(24),
        'swift-cast': cell(25),
        'long-reach': cell(26),
        'blank-charm': cell(27),
      },
      meta: {
        image: '/sprites/icons/icons.png',
        size: { w: 2560, h: 2560 },
        scale: '1',
      },
    },
  },
];
